"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IceCapMelting = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var IceCapMelting = (function (_super) {
    __extends(IceCapMelting, _super);
    function IceCapMelting() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.ICE_CAP_MELTING,
            cost: 5,
            tr: { oceans: 1 },
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(2); }),
            metadata: {
                cardNumber: '181',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.oceans(1); }),
                description: 'Requires +2 C or warmer. Place 1 ocean tile.',
            },
        }) || this;
    }
    IceCapMelting.prototype.play = function (player) {
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
        return undefined;
    };
    return IceCapMelting;
}(Card_1.Card));
exports.IceCapMelting = IceCapMelting;
